// extracted by mini-css-extract-plugin
export default {"form":"CourseForm_form__qYgp2","field":"CourseForm_field__72m2-","checkboxField":"CourseForm_checkboxField__z3Uhb","formButtons":"CourseForm_formButtons__JPrwh"};